




import React, { useState, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'


import LocalStorageService from '../../../services/LocalStorageService'
import NotificationService from '../../../services/NotificationService'
import UserService from '../../../services/UserService'
import OrganisationTagService from '../../../services/OrganisationTagService'
import UserTagService from '../../../services/UserTagService'
import UserGroupService from '../../../services/UserGroupService'
import UserGroupMemberService from '../../../services/UserGroupMemberService'

import { capitalize } from '../../../utils/text'
import constants from '../../../utils/constants'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'


// Appt Components
import Box from '../../../components/simple/box/Box'
import Divider from '../../../components/simple/divider/Divider'
import FontAwesome from '../../../components/compound/fontAwesome/FontAwesome'
import Form from '../../../components/simple/form/Form'
import FormField from '../../../components/simple/formField/FormField'
import Select from '../../../components/simple/input/Select'
import H4 from '../../../components/simple/heading/H4.js'
import Text from '../../../components/simple/text/Text'
import TextInput from '../../../components/simple/input/TextInput'
import DateInput from '../../../components/simple/input/DateInput'
import List from '../../../components/simple/list/List'

import moment from 'moment'
import ActionButton from '../../../components/compound/actionButton/ActionButton.js'
import PulseLoader from 'react-spinners/PulseLoader.js'

function Details (props) {
    const navigate = useNavigate()

    const [loading, setLoading] = useState(false)

    const apiToken = LocalStorageService.get('apiToken')
    const activeOrg = LocalStorageService.get('activeOrg')
    const terms = LocalStorageService.get('terms')
    

    const params = useParams()
    var userId = params.userid

    const [userDetails, setUserDetails] = useState({
        firstName: '',
        lastName: '',
        email: '',
        reference: '',
        dob: '',
        ethnicity: '',
        gender: ''
    })

    useEffect(() => {
        setUserDetails(props.userDetails)
    },[props.userDetails])

    const [groupDetails, setGroupDetails] = useState({
        groupName: '',
        academicYear: ''
    })

    const [allGroups, setAllGroups] = useState([])
    const [currentGroups, setCurrentGroups] = useState([])


    const [allAcademicYears, setAllAcademicYears] = useState([])
    const [academicYearSelected, setAcademicYear] = useState()
        

    useEffect(() => {
        let unmounted = false

        setLoading(true)

        // Check if adding a new User or editing an existing one
        // Get enabled academic year for organisation
        const getAcademicYears = async () => {
          const parsedAcademicYears = await OrganisationTagService.getAcademicYears(apiToken, activeOrg)
          setAllAcademicYears(parsedAcademicYears)
        }

        // Get selected academic year for this user
        const getAcademicYear = async () => {
          if (userId === 'new') {
              setGroupDetails(groupDetails => ({
              ...groupDetails,
              academicYear: 'Not Specified'
              }))
          } else {
              const params = {
              fields: 'key,value'
              }

              const where = {
              organisation: activeOrg.id,
              type: 'besmart',
              user: userId
              }

              const userTags = await UserTagService.get(apiToken, params, where)

              if (userTags) {
              const academicYear = userTags.find(tag => tag.key === 'academicYear')
              setGroupDetails(groupDetails => ({
                  ...groupDetails,
                  academicYear: academicYear.value
              }))
              } else {
              setGroupDetails(groupDetails => ({
                  ...groupDetails,
                  academicYear: 'Not Specified'
              }))
              }
          }
        }

        getAcademicYears()

        getGroups()

        getAcademicYear().then(() => {
            setLoading(false)
        })


        return () => { unmounted = true }
    }, [])

    const submitUserDetails = async (values) => {
    
        if (userId === 'new') {
          const data = {
            data: {
              reference: values.reference,
              dob: moment(values.dob).format('YYYY-MM-DD'),
              firstName: values.firstName,
              lastName: values.lastName,
              ethnicity: values.ethnicity,
              gender: values.gender,
              type: 'student'
            },
            organisation: activeOrg.id
          }
          var userAdded = await UserService.createUser(apiToken, data)
          if (userAdded.error) {
            NotificationService.error(userAdded.error)
          } else {
            NotificationService.success(capitalize(terms?.serviceUser || 'Service User') + ' created. Please add Groups and Key Contacts.')
    
            userId = userAdded.data.id[0]
            navigate(`/serviceuser/${userId}/edit`)
          }
        } else {
          const data = {
            id: values.id,
            reference: values.reference,
            dob: moment(values.dob).format('YYYY-MM-DD'),
            firstName: values.firstName,
            lastName: values.lastName,
            ethnicity: values.ethnicity,
            gender: values.gender
          }
    
          data.id = userId
    
          var userUpdated = await UserService.updateUser(apiToken, data, 'student')
          if (userUpdated?.error) {
            NotificationService.error(userUpdated.error)
          } else {
            NotificationService.success('Success')
          }
        }
      }

      // Submit Group Details
        const submitGroup = async (values) => {
      
          const data = {
            data: {
              name: values.groupName,
              organisation: activeOrg.id
            }
          }
          const groupAdded = await UserGroupService.createGroup(apiToken, data)
          if (groupAdded.error) {
            NotificationService.error(groupAdded.error)
          } else {
            const memberData = {
              data: {
                usergroup: groupAdded.data[0].id,
                user: parseInt(userId)
              }
            }
            const groupMemberAdded = await UserGroupMemberService.create(apiToken, memberData)
      
            setGroupDetails(previousValues => {
              return {
                ...previousValues,
                groupName: ''
              }
            })
      
            NotificationService.success('Group added')
            getGroups()
          }
        }

    
      const addToGroup = async () => {
        const memberData = {
          data: {
            usergroup: groupDetails.groupNameSelect,
            user: parseInt(userId)
          }
        }
        const groupMemberAdded = await UserGroupMemberService.create(apiToken, memberData)
        getGroups()
      }
    
      const getGroups = async () => {
        if (userId !== 'new') {
          const where = {
            user: parseInt(userId)
          }
    
          // Find groups user is a member of
          const memberOf = await UserGroupMemberService.getMultiple(apiToken, null, where)
    
          // Now find all groups
          const params = {
            fields: 'id,name,description,owner,organisation'
          }
    
          // where = {
          //   id: memberOf.data.map(item => { return item.usergroup })
          // }
    
          // Now get all groups
          const groups = await UserGroupService.getGroups(apiToken, params, where)
    
          if (groups?.data) {
            setAllGroups(groups.data)
    
            // Add the group name to memberOf
            if (memberOf?.data) {
              let groupFound = false
              memberOf.data.forEach(item => {
                groupFound = groups.data.find(e => e.id === item.usergroup)
                if (groupFound !== undefined) {
                  item.name = groupFound.name
                }
              })
    
              const myGroups = memberOf.data.filter((item) => { return !groups.data.includes(item) })
    
              // Merge the two arrays such that
              // id=memberOf id for deletion purposes
              // const mergedGroups = memberOf.data.map(itm => ({
              //   ...myGroups.find((item) => (item.id === itm.usergroup) && item),
              //   ...itm
              // }))
    
              // And create a render list
              const mappedGroups = myGroups.map(item => ({
                // name: <Text>{item.name}</Text>
                name: <><Text>{item.name}</Text><ActionButton label={<Text><FontAwesome icon={['fal', 'minus-circle']} /></Text>} margin={{ horizontal: 'xsmall' }} style={{ background: 'besmartOrange' }} onClick={() => removeFromGroup(item.id)} target='_self' /></>
              }))
    
              setCurrentGroups(mappedGroups)
            }
          }
        }
      }
    
      const removeFromGroup = async (groupId) => {
        const result = await UserGroupMemberService.removeFromGroup(apiToken, groupId)
        if (!result?.data?.success) {
          NotificationService.error('There has been an error processing this request. Please try again.')
        } else {
          getGroups()
          NotificationService.info('Removed from group')
        }
      }


        // Add the academic year to user tags
        const addAcademicYear = async (userId, year) => {
      
          // don't allow blank years
          if (!year) {
            NotificationService.warning('There has been no change to the academic year')
            return
          }
      
          const data = [
            {
              key: 'academicYear',
              organisation: activeOrg.id,
              type: 'besmart',
              user: userId,
              value: year
            }
          ]
      
          const tagSet = await UserTagService.set(apiToken, data)
          if (tagSet.error) {
            NotificationService.error(tagSet.error)
          } else {
            NotificationService.success('Year Group updated')
          }
        }
    

    const ethnicityInput = activeOrg.wondeSync === true ? 
        <TextInput
            name='ethnicity'
            type='text'
        />
        :
        <Select
            name='ethnicity'
            labelKey='label'
            options={constants.ethnicity}
            valueKey={{ key: 'value', reduce: true }}
        />


  if (loading) {
    return <Box direction='row' gap='medium' >
      <Box background='white' direction='column' gap='small' margin={{ top: 'small', bottom: 'large' }} border={{ color: 'light-4', side: 'right' }} pad='medium' flex='grow'>
        <PulseLoader color='#ff8300' size={15} margin={5} />
      </Box>
    </Box>
  }

  return (
    <Box direction='row' gap='medium' margin={{ top: 'small', bottom: 'larmediumge' }}>
    <Box background='white' direction='column' gap='small'  border={{ color: '#eee', side: 'right' }} pad='small' flex='grow'>

      <Box
        gap='small'
        round='small'
      >
        <>
            
        <Form
          onChange={nextValue => {
            setUserDetails(nextValue)
          }}
          onSubmit={({ value: nextValue }) => {
            if (nextValue.dob === '') {
              nextValue.dob = undefined
            }
            submitUserDetails(nextValue)
          }}
          value={userDetails}
        >
          <H4 color='secondary' margin={{ top: 'none', bottom: 'small' }}>{capitalize(terms?.serviceUser || 'Service User')} Details</H4>

          <Box direction='row-responsive' gap='medium'>
            <FormField
              label='First Name'
              name='firstName'
              required
            >
              <TextInput
                name='firstName'
                type='text'
              />
            </FormField>

            <FormField
              label='Last Name'
              name='lastName'
              required
            >
              <TextInput
                name='lastName'
                type='text'
              />
            </FormField>
          </Box>

          <Box direction='row-responsive' gap='medium'>
            <FormField
              label='Learner Number (if applicable)'
              name='reference'
            >
              <TextInput
                name='reference'
                type='text'
              />
            </FormField>

            <FormField
              label='Date of Birth'
              name='dob'
            >
              <DateInput
                buttonProps={{ backgroundColor: 'white' }}
                // value={(new Date()).toISOString()}
                // onChange={(new Date()).toISOString()}
                format='dd/mm/yyyy'
                name='dob'
              />

            </FormField>
          </Box>

          <Box direction='row-responsive' gap='medium'>
            <FormField
              label='Ethnicity'
              name='ethnicity'
            >
             { ethnicityInput } 
            </FormField>

            <FormField
              label='Gender'
              name='gender'
            >
              <Select
                name='gender'
                labelKey='label'
                options={constants.gender}
                valueKey={{ key: 'value', reduce: true }}
              />
              {/* <TextInput
                name='gender'
                type='text'
              /> */}
            </FormField>
          </Box>

          <Box direction='row' justify='between' margin={{ top: 'medium' }}>
            <ActionButton type='submit' label='Save' primary />
          </Box>
        </Form>
        </>
      </Box>
    </Box>
    <Box background='white' direction='column' gap='small' round='small' margin={{ bottom: 'large' }}  pad='small' >
      <Form
                onChange={nextValue => {
                  setGroupDetails(nextValue)
                }}
                onSubmit={({ value: nextValue }) => {
                  submitGroup(nextValue)
                }}
                value={groupDetails}
              >
                {allAcademicYears?.length > 0 &&
                  <>
                    <H4 color='secondary' margin={{ top: 'none', bottom: 'small' }}>Year Group</H4>
                    <FormField
                      label='Current Year Group'
                      name='academicYear'
                    >
                      <Select
                        name='academicYear'
                        emptySearchMessage='No academic years configured in service setup'
                        onChange={
                          (event, option) => { setAcademicYear(event.value) }
                        }
                        options={allAcademicYears}
                      />
                    </FormField>
                    <ActionButton margin='none' onClick={() => addAcademicYear(userId, academicYearSelected)} label='Save Academic Year' primary />

                  </>}
      
                <Divider color='#eee' margin={{ top: 'medium', bottom: 'medium' }} />
      
                <H4 color='secondary' margin={{ top: 'none', bottom: 'small' }}>{capitalize(terms?.serviceUser || 'Service User')} Groups</H4>
                <Box direction='row-responsive' gap='medium'>
                  <Box direction='column' gap='small'>
                    <Text size='small'>Current groups</Text>
                    {currentGroups.length > 0
                      ? <List border={false} data={currentGroups} primaryKey='name' />
                      // ? <DataTable
                      //   columns={behaviourLeadColumns}
                      //   data={currentGroups}
                      //   // fill='horizontal'
                      //   // size='large'
                      // />
      
                      : <Text>Not a member of a group</Text>}
                  </Box>
                </Box>
                <Box direction='row-responsive' gap='medium'>
                  <Box direction='column'>
                    <FormField
                      label='Add to Group'
                      name='groupNameSelect'
                    >
                      <Select
                        name='groupNameSelect'
                        labelKey='name'
                        options={allGroups}
                        valueKey={{ key: 'id', reduce: true }}
                      />
                    </FormField>
                    <ActionButton alignSelf='end' label={<Text><FontAwesomeIcon icon={['fal', 'plus-circle']} /> Add</Text>} margin={{ bottom: 'small' }} onClick={() => addToGroup()} style={{ height: '45px', background: 'besmartOrange' }} />
                  </Box>
      
                  <Box direction='column'>
                    <FormField
                      label='Create Group'
                      name='groupName'
                      required
                    >
                      <TextInput
                        name='groupName'
                        type='text'
                      />
                    </FormField>
                    <ActionButton type='submit' label={<Text><FontAwesomeIcon icon={['fal', 'plus-circle']} /> Create</Text>} style={{ height: '45px', background: 'besmartOrange' }} alignSelf='end' margin={{ bottom: 'small' }} />
                  </Box>
                </Box>
    
              </Form>
          </Box>
  </Box>)
}
export default Details
